import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "antd";
import { SearchOutlined } from "@mui/icons-material";
import GetAddOrder from "./GetAllOrders/AllOrders";
import { useLoader } from "../../../utils/LoaderContext"; // ✅ Import added
import Shipping from "./GetAllOrders/Shipping";
import Manifest from "./GetAllOrders/Manifest";
import Live from "./GetAllOrders/Live";
import PickUpPending from "./GetAllOrders/PickUpPending";
import Rto from "./GetAllOrders/Rto";
import Cancelled from "./GetAllOrders/Cancelled";
import Delivered from "./GetAllOrders/Delivered";
import GetManifests from "./GetAllOrders/Manifested";

const AllOrders = () => {
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const [activeTab, setActiveTab] = useState("  ");
  const { setLoading } = useLoader();
  const location = useLocation();

  const tabList = [
    { key: "new", label: "New", color: "bg-primary" },
    {
      key: "shipping",
      label: "Ready To Ship",
      color: "bg-primary",
    },
    { key: "manifest", label: "Manifest", color: "bg-primary" },
    { key: "pickup", label: "Pickup Pending", color: "bg-primary" },
    { key: "live", label: "Live Orders", color: "bg-primary" },
    {
      key: "returns",
      label: "RTO",
      color: "bg-primary",
    },
    {
      key: "cancelled",
      label: "Cancelled",
      color: "bg-primary",
    },
    {
      key: "delivered",
      label: "Delivered Orders",
      color: "bg-primary",
    },
    { key: "allOrders", label: "All Orders", color: "bg-primary" },
    // { key: "manifested", label: "Manifested", color: "bg-primary" },
    // { key: "cancelled", label: "Cancelled", color: "bg-primary"  },
  ];

  // Optional: simulate loading delay on tab switch
  useEffect(() => {
    setLoading(true);
    const timeout = setTimeout(() => setLoading(false), 500); // Simulated API delay
    return () => clearTimeout(timeout);
  }, [activeTab, setLoading]);

  useEffect(() => {
    const tabFromURL = new URLSearchParams(location.search).get("tab");
    if (tabFromURL) {
      setActiveTab(tabFromURL);
    } else {
      // Set default tab to "new"
      navigate("?tab=new", { replace: true });
    }
  }, [location.search, navigate]);

  const renderTable = () => {
    switch (activeTab) {
      case "new":
        return <div></div>;

      case "shipping":
        return <Shipping status="pendings" />;
      case "manifest":
        return <Manifest status="shipped" />;
      case "pickup":
        return <PickUpPending status="pickup" />;
      case "live":
        return <Live status="live" />;
      case "returns":
        return <Rto status="returns" />;
      case "cancelled":
        return <Cancelled status="cancelled" />;
      case "delivered":
        return <Delivered status="delivered" />;
      case "allOrders":
        return <GetAddOrder searchText={searchText} />;
      // case "manifested":
      //   return <GetManifests searchText={searchText} />;
      default:
        return <></>; // Fallback
    }
  };

  return (
    <div className="flex flex-col h-screen max-w-full mx-auto">
      {/* Sticky Header */}
      <div className="sticky top-0 z-10 bg-white border-b shadow-sm">
        <div className="flex justify-between items-center px-4 py-2 gap-4 flex-wrap">
          {/* Search */}
          <div className="relative w-full sm:w-80">
            {/* <Input
              placeholder="Search Order ID, Name, etc."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              prefix={<SearchOutlined />}
              className="border border-gray-300"
            /> */}
          </div>

          {/* Create Order Button */}
          <button
            onClick={() => navigate("/orders/create-order")}
            className="px-6 py-2 text-primary bg-primaryLight border border-primary hover:text-white hover:bg-primary rounded whitespace-nowrap"
          >
            Create Orders
          </button>
        </div>

        {/* Tabs */}
        <div className="relative w-full bg-white border-t">
          <div className="flex gap-2 px-4 py-2 overflow-x-auto hide-scrollbar scroll-smooth">
            {tabList.map((tab) => (
              <button
                key={tab.key}
                onClick={() => navigate(`?tab=${tab.key}`)}
                className={`px-4 py-1 text-sm rounded border transition-colors duration-300 whitespace-nowrap
          ${
            activeTab === tab.key
              ? `${tab.color} text-white ring-2 ring-offset-1 ring-white`
              : "text-primary bg-primaryLight hover:bg-primary hover:text-white border-primary"
          }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Main Content: Table */}
      <div className="flex-1 overflow-auto bg-gray-50 p-4">
        <div className="w-full overflow-x-auto">
          <div className="min-w-[1000px]">{renderTable()}</div>
        </div>
      </div>
    </div>
  );
};

export default AllOrders;
